import { ErrorMessage } from "formik";
import "./style.css";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import classNames from "classnames";
import data_en from "./countries.json";
import data_fr from "./countries_fr.json";


interface Props {
  name: string;
  label?: string;
  required?: boolean;
  placeholder?: string;
  value?: string;
  setFieldValue?: any;
  errors?: any;
  lang?: string;
}

interface Option {
  value: string;
  label: string;
}

const FormFieldCountrySelect = ({ name, label, required, setFieldValue, errors, value, lang } : Props) => {
    const [countries, setCountries] = useState([] as Option[]);
    const [selectedCountry, setSelectedCountry] = useState({});
    let data = lang === 'fr' ? data_fr : data_en;
    console.log("LANG ", lang);
    useEffect(() => {
      setCountries(data.countries);
      if(value) {
        let newCountry = data.countries.find((country)=> country.label == value);
        setSelectedCountry(newCountry!);
      } 
      /*else {
        setSelectedCountry(data.userSelectValue);
      }*/
      if(setFieldValue){
        if(value) {
          setFieldValue(name, value);
        } 
        /*else {
          console.log("VALUES ", data.userSelectValue.label);
          setFieldValue(name, data.userSelectValue.label);
        }*/
      }
    }, [value]);

    return (
      <div className={"d-block w-100 form-field col-12 mt-0 p-0"}>
        {label && <label className="form-label mb-2 w-100" htmlFor={name} >{label} {required && <span className=" text-danger">*</span>}</label>}
        
          <div className="w-100">
              <Select
                name={name} 
                id={name} 
                options={countries}
                value={selectedCountry}
                // errors={errors}
                onChange={(selectedOption) => {
                  setSelectedCountry(selectedOption!);
                  let newOption = selectedOption as Option;
                  setFieldValue(name, newOption?.label);
                }}
              />
          </div>
          <div className="span field-error"> 
            <ErrorMessage name={name}/>
          </div>
      </div>
    );
  };

export default FormFieldCountrySelect;